import { NgModule } from '@angular/core';
import { routes } from './app.routes';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ComponenteLogin } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Navbar } from './navbar/navbar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { IncongruenciasComponent } from './incongruencias/incongruencias.component';
import { PlanComponent } from './plan/plan.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { TitularYAdherentesComponent } from './titular-y-adherentes/titular-y-adherentes.component';
import { PersonaComponent } from './persona/persona.component';
import {
  NgbModule,
  NgbDatepickerI18n,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { PersonaModalComponent } from './persona-modal/persona-modal.component';
import { PlanModalComponent } from './plan-modal/plan-modal.component';
import { CommonModule } from '@angular/common';
import { SubirArchivoComponent } from './subir-archivo/subir-archivo.component';
import { PersonaComparacionComponent } from './persona-comparacion/persona-comparacion.component';
import { UsuarioModalComponent } from './usuario-modal/usuario-modal.component';
import { CustomDatepickerI18n } from './services/custom-datepicker-i18n.service';
import { CustomDateAdapter } from './services/custom-date-adapter';
import { CustomDateParserFormatter } from './services/custom-date-parser-formatter';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { CodigoGestosComponent } from './codigo-gestos/codigo-gestos.component';
import { UsuarioEditarComponent } from './usuario-editar/usuario-editar.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { VendedorComponent } from './vendedor/vendedor.component';
import { VendedorModalComponent } from './vendedor-modal/vendedor-modal.component';
import { EmpresaComponent } from './empresa/empresa.component';
import { EmpresaModalComponent } from './empresa-modal/empresa-modal.component';
import { ModalFacturasPendientesComponent } from './home/modal-facturas-pendientes.component';

registerLocaleData(localeEs);
@NgModule({
  declarations: [
    AppComponent,
    ComponenteLogin,
    HomeComponent,
    Navbar,
    TopbarComponent,
    IncongruenciasComponent,
    PlanComponent,
    UsuarioComponent,
    TitularYAdherentesComponent,
    PersonaComponent,
    PersonaModalComponent,
    PlanModalComponent,
    SubirArchivoComponent,
    PersonaComparacionComponent,
    UsuarioModalComponent,
    CodigoGestosComponent,
    UsuarioEditarComponent,
    VendedorComponent,
    VendedorModalComponent,
    EmpresaComponent,
    EmpresaModalComponent,
    ModalFacturasPendientesComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    FontAwesomeModule,
    RouterModule.forRoot(routes),
    NgbModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
